import Rollbar from "rollbar"

export default class Logger {

  /** @type {Rollbar} */
  _rollbar = null

  /**
   * 
   * @param {Rollbar} rollbar 
   */
  setRollbar(rollbar) {
    this._rollbar = rollbar
  }

  _hasRollbar() {
    return (this._rollbar !== null)
  }

  debug(message, ...params) {
    this._log('debug', message, ...params)
  }

  error(message, ...params) {
    this._log('error', message, ...params)
  }

  info(message, ...params) {
    this._log('info', message, ...params)
  }

  warn(message, ...params) {
    this._log('warn', message, ...params)
  }


  _log(type = 'debug', message, ...params) {
    if (this._hasRollbar()) {
      this._rollbar[type](message, ...params)
    } else {
      console[type](message, ...params)
    }
  }
}